import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/helpers/authentication'
import ManagerRoutes from './manager'
import CustomerRoutes from './customer'
import SharedRoutes from './shared'

Vue.use(VueRouter)

const routes = [...CustomerRoutes, ...ManagerRoutes, ...SharedRoutes];

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const userData = Auth.isAuthenticated()
  const accessChecks = to.matched
    .map(route => route.meta && route.meta.check)
    .filter(Boolean)
  const protectedRole = accessChecks.find(check => check === 'manager' || check === 'customer')
  const isLoggedOutOnly = accessChecks.includes('loggedOut')

  if (protectedRole && (!userData || userData.role !== protectedRole)) {
    Auth.clearStorage()
    return next('/login')
  }

  if (isLoggedOutOnly && userData) {
    if (userData.role === 'manager' || userData.role === 'customer') {
      return next('/' + userData.role)
    }
  }

  return next()
})

export default router
